import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoContrattiAClienteStep2Component } from './conservazione-carica-documento-contratti-a-cliente-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-contratti-a-cliente-step2', {
            url: '/conservazione-carica-documento-contratti-a-cliente',
            ncyBreadcrumb: {
                label: 'Carica Contratti a Cliente',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-contratti-a-cliente-step2 flex="100"></conservazione-carica-documento-contratti-a-cliente-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoContrattiAClienteStep2Module: string = ng
    .module('conservazione-carica-documento-contratti-a-cliente-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoContrattiAClienteStep2', ConservazioneCaricaDocumentoContrattiAClienteStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-contratti-a-cliente-step2/conservazione-carica-documento-contratti-a-cliente-step2.module.ts